<script setup lang="ts">
import type { EventSummaryResponse } from '@@/types/api';

defineProps<{
  events: EventSummaryResponse[];
  loading: boolean;
}>();
</script>

<template>
  <section class="marketing-section">
    <div class="marketing-section__content">
      <h2 class="text-h4 text-center font-weight-bold mb-10">
        Events You Can Join
      </h2>

      <!-- Loading -->
      <v-row v-if="loading">
        <v-col v-for="n in 3" :key="n" cols="12" sm="6" md="4">
          <v-skeleton-loader type="card" />
        </v-col>
      </v-row>

      <!-- Empty -->
      <div v-else-if="!events.length" class="text-center py-8">
        <v-icon size="64" color="medium-emphasis" class="mb-4">
          mdi-calendar-star
        </v-icon>
        <p class="text-h6 text-medium-emphasis mb-4">
          No events yet — check back soon!
        </p>
        <v-btn to="/browse" color="primary" size="large"> Browse Events </v-btn>
      </div>

      <!-- Populated -->
      <template v-else>
        <v-row>
          <v-col
            v-for="event in events"
            :key="event.id"
            cols="12"
            sm="6"
            md="4"
          >
            <EventsEventCard :event="event" />
          </v-col>
        </v-row>

        <div class="text-center mt-8">
          <v-btn to="/browse" variant="outlined" color="primary" size="large">
            See all events
          </v-btn>
        </div>
      </template>
    </div>
  </section>
</template>
